export function downloadBase64EncodedCsv(base64Csv: string, mimeType = "text/csv") {
    const byteCharacters = atob(base64Csv);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 10000);
}
